import React from 'react';

export default function StepUpIframe({
    iframeRef,
    overlayRef,
}) {
    return <>
        <div
            ref={overlayRef}
            style={{
                display: 'none',
                background: 'rgba(0, 0, 0, 0.7)',
                zIndex: 999,
                position: 'fixed',
                id: 'overlay',
                left: 0,
                top: 0,
                bottom: 0,
                right: 0,
            }}
        />
        <iframe
            ref={iframeRef}
            name="3ds_step_up_iframe"
            height=""
            width=""
            style={{
                display: 'none',
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 999,
                backgroundColor: "white",
                border: '1px solid #222222',
                boxShadow: '5px 5px 10px 1px #222222',
            }}
        />
    </>;
}


